import { notification } from '@surecompanies/core_components'
import { useMutation } from '@tanstack/react-query'
import { CompanyStatusEnum } from 'constants/company'
import client from 'enrollment-platform/api/eps.client'
import { CUSTOMER_MANAGEMENT } from 'enrollment-platform/pages/CustomerManagement/paths'
import { browserHistory } from 'react-router'

export default function useNewCustomer() {
  const createCustomer = async (data: any) => {
    try {
      const response = await client.post('/customers', {
        ...data,
        isActive: data.status === CompanyStatusEnum.ACTIVE,
      })
      notification.success({
        message: 'Customer successfully created',
      })
      browserHistory.push(`/${CUSTOMER_MANAGEMENT}/${response.data.id}/view`)
    } catch (error: any) {
      // is axios error
      if (error?.response?.data?.message) {
        notification.error({
          duration: 60, // 60 seconds
          message: error.response.data.message,
        })
      } else {
        notification.error({
          message: `Error creating customer: ${error.message}`,
          duration: 60, // 60 seconds
        })
      }
    }
  }

  const { mutate, isPending } = useMutation({
    mutationFn: createCustomer,
    mutationKey: ['createCustomer'],
  })
  return {
    mutate,
    isPending,
  }
}
